import { darken, lighten, rgba } from "polished";
import defaultsDeep from "lodash/defaultsDeep";
import { white } from "../colors";
import { brandPrimary, brandSecondary } from "../colors/brand";
import * as steelGrey from "../colors/steelGrey";
import * as deepBlue from "../colors/deepBlue";
import * as green from "../colors/green";
import * as red from "../colors/red";
import { alchemyLight } from "./alchemy-light";
export const alchemyBrand = defaultsDeep({
    // Base (structural)
    structural: {
        base: lighten(0.382, brandPrimary),
        inverse: white,
        contrast: darken(0.3, brandPrimary),
        highlight: lighten(0.125, brandPrimary),
        hint: lighten(0.05, brandPrimary),
        // Brand colors
        brandPrimary,
        brandSecondary,
        // Text colors
        typeLink: deepBlue.deepBlue100,
        typeHeader: white,
        typeSubHeader: white,
        typeBody: white,
        typeMeta: lighten(0.125, brandPrimary),
        // UI
        line: lighten(0.15, brandPrimary),
        lineContrast: lighten(0.2, brandPrimary),
        inputBorder: lighten(0.15, steelGrey.steelGrey300),
        fill: lighten(0.015, brandPrimary),
        canvas: lighten(0.02, brandPrimary),
        container: lighten(0.035, brandPrimary)
    },
    interactiveAction: {
        contrast: darken(0.02, green.green1000),
        base: green.greenA500,
        highlight: rgba(green.greenA500, 0.5),
        hint: rgba(green.greenA500, 0.3)
    },
    interactiveNavigational: {
        contrast: steelGrey.steelGrey600,
        base: rgba(steelGrey.steelGrey500, 0.95),
        highlight: rgba(steelGrey.steelGrey500, 0.65),
        hint: rgba(steelGrey.steelGrey500, 0.4)
    },
    interactiveConstructive: {
        contrast: darken(0.02, brandPrimary),
        base: darken(0.058, brandPrimary),
        highlight: rgba(darken(0.058, brandPrimary), 0.6),
        hint: rgba(darken(0.058, brandPrimary), 0.4)
    },
    interactiveDestructive: {
        contrast: darken(0.02, red.redA500),
        base: red.redA400,
        highlight: rgba(red.redA400, 0.2),
        hint: red.redA400
    }
}, alchemyLight);
